import React from 'react';

const Prose = ({ children, className = '' }) => {
  return (
    <div className={`prose prose-lg max-w-none ${className}`}>
      <style jsx>{`
        .prose {
          color: #374151;
          line-height: 1.75;
        }
        .prose h2 {
          color: #111827;
          font-weight: 700;
          font-size: 1.875rem;
          margin-top: 2rem;
          margin-bottom: 1rem;
          font-family: 'Mollen', sans-serif;
        }
        .prose h3 {
          color: #111827;
          font-weight: 600;
          font-size: 1.5rem;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
          font-family: 'Mollen', sans-serif;
        }
        .prose h4 {
          color: #111827;
          font-weight: 600;
          font-size: 1.25rem;
          margin-top: 1.25rem;
          margin-bottom: 0.5rem;
        }
        .prose p {
          margin-bottom: 1.25rem;
        }
        .prose ul, .prose ol {
          margin-bottom: 1.25rem;
          padding-left: 1.5rem;
        }
        .prose li {
          margin-bottom: 0.5rem;
        }
        .prose a {
          color: #ab3d22;
          text-decoration: underline;
        }
        .prose a:hover {
          color: #a02a15;
        }
        .prose strong {
          font-weight: 600;
          color: #111827;
        }
        .prose blockquote {
          border-left: 4px solid #ab3d22;
          padding-left: 1rem;
          margin: 1.5rem 0;
          font-style: italic;
          color: #6b7280;
        }
        .prose code {
          background-color: #f3f4f6;
          padding: 0.125rem 0.25rem;
          border-radius: 0.25rem;
          font-size: 0.875rem;
        }
      `}</style>
      {children}
    </div>
  );
};

export default Prose;
